import React, {Suspense} from 'react';

import {SkeletonData} from 'presentation/components/ChangeData/SkeletonData';
import {usePersonalData} from 'presentation/hooks';
import {useChangeDataProfile} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';
import {AddressField} from '../AddressField';
import {DataAccordion} from '../DataAccordion';
import {AccordionStateEnum} from '../../store/formAccordionStore/types';

const {changeData} = translations['pt-br'].privateFlow.profile;

export function AddressSection() {
	const {emptyLocation} = usePersonalData();
	const {handleChangeDataFocus, changeDataFormState} = useChangeDataProfile();

	return (
		<DataAccordion
			hideIcon={emptyLocation}
			expanded={changeDataFormState.name === AccordionStateEnum.ADDRESS}
			handleChangeExpanded={() => handleChangeDataFocus(AccordionStateEnum.ADDRESS)}
			title={changeData.address.title}
			icon="perm-contact-callendar-filled">
			<Suspense fallback={<SkeletonData type="address" />}>
				<AddressField />
			</Suspense>
		</DataAccordion>
	);
}
